import { render, staticRenderFns } from "./SkidList.vue?vue&type=template&id=b75f1462&scoped=true"
import script from "./SkidList.vue?vue&type=script&lang=js"
export * from "./SkidList.vue?vue&type=script&lang=js"
import style0 from "./SkidList.vue?vue&type=style&index=0&id=b75f1462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75f1462",
  null
  
)

export default component.exports